import React from "react";
import { sortBy } from "lodash";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderField, renderSelect } from "./_fieldRenderer";
import { db } from "../services/firebase";

import "./forms.css";

class ProductForm extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;
    this.state = {
      lines: [],
      fetchingLines: false,
    };
  }

  componentDidMount() {
    const lines = [];
    this.setState({ fetchingLines: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("lines")
      .get()
      .then((lineSnapshot) => {
        if (!lineSnapshot.empty) {
          lineSnapshot.forEach((line) =>
            lines.push({
              value: line.id,
              label: `${line.data().name}`,
            })
          );
          this.setState({ fetchingLines: false, lines });
        } else {
          this.setState({ fetchingLines: false, lines });
        }
      });
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="name"
                type="text"
                component={renderField}
                label="Nome"
                placeholder="Nome"
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                name="lines"
                component={renderSelect}
                label="Linha"
                disabled={!this.state.lines.length}
                placeholder={this._handlePlaceholder(this.state.lines)(
                  this.state.fetchingPlaces
                )("male")}
                options={sortBy(this.state.lines, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Salvar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };
  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}
const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Obrigatório";
  }
  if (!values.lines) {
    errors.lines = "Obrigatório";
  }
  return errors;
};

ProductForm = reduxForm({ form: "ProductForm", validate })(ProductForm);
export default ProductForm;



// WEBPACK FOOTER //
// ./src/forms/ProductForm.jsx